export default "__VITE_ASSET__CH_RRhKp__"